export default {
      id: "mail-usage",
      viewBox: "0 0 511.626 511.626",
      url: __webpack_public_path__ + "app/svg/sprite.svg#mail",
      toString: function () {
        return this.url;
      }
    }